import { useQuery } from 'react-query';

import { getCardComment as queryFn } from 'api/endPoints/getCardComment';

import { IComment } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

export const useQueryGetCardComments = (params) => {
    return useQuery<IComment[], QueryError>(['getCardComment', params], () => queryFn(params), {
        enabled: Boolean(params.id),
    });
};
